/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FunctionComponent, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Attribute, ThemeTemplateGroup, TryOnMode, useZakeke } from 'zakeke-configurator-react';
import './selector.css';
import './Menu/menu.css';
import { QuestionDialog, useDialogManager } from '../components/dialogs/Dialogs';
import SvgArrowDown from '../icons/Arrowdown';
import Loader from '../components/Loader/Loader';
import {
  clearAllWaistbandSelections,
  hasTextOrImageItemsInAreaByName,
  hasTextOrImageItemsInAreaByName1,
  hasTextOrImageItemsInAreaByPlaceholder,
  hasTextOrImageItemsInAreaByPlaceholder1,
  removeItems,
  removeItemsForStyle,
} from './Atomic';
import MenuFooter from './Footer/MenuFooter';
import Zoom from './Zoom/Zoom';
import {
  findAttribute,
  findGroup,
  findStep,
  useActualGroups,
  useUndoRegister,
  useUndoRedoActions,
  T,
} from '../Helpers';
import useStore from '../Store';
import {
  Container,
  ExpandedContent,
  MenuGroup,
  MenuItem,
  NavigationButton,
  OptionContainer,
  SubSection,
  SubSectionTitle,
  SubSubSectionTitle,
  TabContainer,
} from './Layout/LayoutStyles';
import Designer from './Layout/Designer';
import { UndoRedoStep } from '../Interfaces';
import NftDialog, { NftForm } from './dialogs/NftDialog';
import SvgArrowDownBlack1 from '../icons/arrowblacksvg';
import { P, PLACEHOLDERS, PLACEHOLDERS_MAPS } from '../Placeholder';

interface OptionCircleProps {
  selected: boolean;
  imageUrl?: string | null;
  isStyle?: boolean;
  isWaist?: boolean;
}

const OptionCircle = styled.div<OptionCircleProps>`
  width: ${({ isStyle, isWaist }) => (isWaist || isStyle ? '95px' : '60px')};
  height: ${({ isStyle, isWaist }) => (isWaist || isStyle ? '95px' : '60px')};
  border-radius: 50%;
  background-color: ${({ imageUrl }) => (imageUrl ? '#ffff' : '#e0e0e0')};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  border: ${({ selected }) => (selected ? '3px solid black' : '2px solid #000')};
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  box-shadow: ${({ selected }) =>
    selected ? '0 4px 12px rgba(0,123,255,0.3)' : '0 2px 4px rgba(0,0,0,0.1)'};

  filter: ${({ selected }) => (selected ? 'none' : 'gray(6%) brightness(95%)')};
  opacity: ${({ selected }) => (selected ? 1 : 0.6)};
  transform: ${({ selected }) => (selected ? 'scale(1)' : 'scale(0.96)')};

  & > .circle-img {
    border-radius: ${({ isStyle }) => (isStyle ? '35%' : '50%')};
    width: ${({ isStyle }) => (isStyle ? '90%' : '100%')};
    height: ${({ isStyle }) => (isStyle ? '80%' : '100%')};
    object-fit: ${({ isStyle }) => (isStyle ? 'contain' : 'cover')};
    overflow: hidden;
  }

  &:hover {
    border: 3px solid rgb(10, 10, 10);
    transform: scale(1.05);
    filter: none;
    opacity: 1;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }

  & > .option-name {
    color: #333;
    font-size: 12px;
    text-align: center;
    word-wrap: break-word;
    padding: 0 5px;
  }

  & > .custom-tooltip {
    visibility: hidden;
    background-color: #333;
    color: #fff;
    font-size: 12px;
    font-family: 'Open Sans', sans-serif;
    padding: 5px;
    border-radius: 4px;
    position: absolute;
    min-width: 100px;
    text-align: center;
    white-space: normal;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover > .custom-tooltip {
    visibility: visible;
    opacity: 1;
  }

  @media (max-width: 768px) {
    width: ${({ isStyle }) => (isStyle ? '65px' : '45px')};
    height: ${({ isStyle }) => (isStyle ? '65px' : '45px')};
  }
`;

const Tab = styled.div<{ active: boolean }>`
  padding: 6px 2px;
  cursor: pointer;
  color: ${({ active }) => (active ? '#000' : '#333')};
  border-bottom: ${({ active }) => (active ? '2px solid black' : 'none')};
  border-radius: 2px;
  font-weight: ${({ active }) => (active ? '700' : '400')};
  transition: all 0.3s ease;
  font-size: 14px;
  font-family: 'Open Sans';
  margin-left: 3px;

  &:hover {
    transition: all 0.3s ease-out;
  }
`;

interface SelectorProps {
  refViewer: any;
  fullScreen: any;
}

interface Option {
  id: number;
  name: string;
  selected: boolean;
  enabled: boolean;
  imageUrl?: string | null;
  cameraLocationId?: string;
  pricings?: {
    fromQuantity: number;
    price: number;
  }[];
}

interface Step {
  id: number;
  name: string;
  attributes: Attribute[];
}

interface Group {
  id: number;
  name: string;
  cameraLocationId?: string | null;
  attributes?: Attribute[];
  steps?: Step[];
}

const SelectionIndicator: React.FC = () => (
  <div className="selector_indicator">
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3262 1.67038C19.3609 0.736162 20.8805 0.843238 21.7952 1.96795L21.9595 2.19159C22.6717 3.26529 22.6369 4.77119 21.8747 5.80586L21.7002 6.01962L10.7445 18.1789L10.7435 18.1798C9.71814 19.3102 8.07768 19.2652 7.10489 18.0951L7.10487 18.0961L1.4039 12.1842L1.38868 12.1682L1.37446 12.1511C0.442677 10.9947 0.493401 9.19491 1.48707 8.09998L1.68856 7.89972C2.71477 6.9821 4.2056 7.08818 5.11814 8.17563L9.0271 11.9689L18.1256 1.87164L18.3262 1.67038Z"
        fill="white"
        stroke="black"
      />
    </svg>
  </div>
);

const OptionItem: React.FC<{
  option: Option;
  isStyle?: boolean;
  isWaist?: boolean;
  onOptionClick: (mouseEvent: React.MouseEvent<HTMLElement>, option: Option) => void;
}> = ({ option, onOptionClick, isStyle = false, isWaist = false }) => {
  if (!option) {
    return null;
  }

  return (
    <OptionCircle
      selected={option.selected}
      imageUrl={option.imageUrl || undefined}
      isStyle={isStyle}
      isWaist={isWaist}
      onClick={(mouseEvent: React.MouseEvent<HTMLElement>) => onOptionClick(mouseEvent, option)}
    >
      {!option.imageUrl && <span className="option-name">{option.name}</span>}

      {option.imageUrl && (
        <img src={option.imageUrl} alt={option.name || ''} className="circle-img" />
      )}

      {option.selected && <SelectionIndicator />}
      <span className="custom-tooltip">{option.name || 'Option'}</span>
    </OptionCircle>
  );
};

const FabricSection: React.FC<{
  groups: Group[];
  onOptionClick: (mouseEvent: React.MouseEvent<HTMLElement>, option: Option) => void;
}> = ({ groups, onOptionClick }) => {
  const { selectOption, setCamera } = useZakeke();
  const { setSelectedAttributeId } = useStore();

  const groupsData = useMemo(() => {
    const findGroup = (placeholderKey: string) =>
      groups.find((group) => P.contains(group.name, placeholderKey));
    return {
      waistbandGroup: findGroup(PLACEHOLDERS.FabricKeyword),
      mainbodyGroup: findGroup(PLACEHOLDERS.WaistbandEmbroideryKeyword),
      sidePanelGroup: findGroup(PLACEHOLDERS.EmbellishmentsAndSponsorsKeyword),
      trimsGroup: findGroup(PLACEHOLDERS.TrimKeyword),
    };
  }, [groups]);
  const optionsData = useMemo(() => {
    const extractOptions = (group: Group | undefined, placeholderKey: string): Option[] =>
      group?.attributes
        ?.find((attr) => P.contains(attr.name, placeholderKey))
        ?.options?.filter((option) => option.enabled !== false) || [];
    const waistbandOptions =
      groupsData.waistbandGroup?.attributes?.flatMap(
        (attr) => attr.options?.filter((option) => option.enabled !== false) || []
      ) || [];

    const mainbodySatinOptions = extractOptions(
      groupsData.mainbodyGroup,
      PLACEHOLDERS.WaistbandEmbroideryMainBodySatinKeyword
    );
    const mainbodySpecialOptions = extractOptions(
      groupsData.mainbodyGroup,
      PLACEHOLDERS.WaistbandEmbroideryMainBodySpecialKeyword
    );
    const sidePanelSatinOptions = extractOptions(
      groupsData.sidePanelGroup,
      PLACEHOLDERS.EmbellishmentsAndSponsorsSatinKeyword
    );
    const sidePanelSpecialOptions = extractOptions(
      groupsData.sidePanelGroup,
      PLACEHOLDERS.EmbellishmentsAndSponsorsSpecialKeyword
    );

    const trimsOptions =
      groupsData.trimsGroup?.attributes?.flatMap(
        (attr) => attr.options?.filter((option) => option.enabled !== false) || []
      ) || [];

    return {
      waistbandOptions,
      mainbodySatinOptions,
      mainbodySpecialOptions,
      sidePanelSatinOptions,
      sidePanelSpecialOptions,
      trimsOptions,
    };
  }, [groupsData]);
  const [mainbodyActiveTab, setMainbodyActiveTab] = useState<'Satin' | 'Special Fabrics'>('Satin');
  const [sidePanelActiveTab, setSidePanelActiveTab] = useState<'Satin' | 'Special Fabrics'>(
    'Satin'
  );
  const [hasInitializedTabs, setHasInitializedTabs] = useState(false);

  const selectedOptions = useMemo(() => {
    const {
      waistbandOptions,
      trimsOptions,
      mainbodySatinOptions,
      mainbodySpecialOptions,
      sidePanelSatinOptions,
      sidePanelSpecialOptions,
    } = optionsData;

    const selectedMainbodySatin = mainbodySatinOptions.find((option) => option.selected);
    const selectedMainbodySpecial = mainbodySpecialOptions.find((option) => option.selected);
    const selectedSidePanelSatin = sidePanelSatinOptions.find((option) => option.selected);
    const selectedSidePanelSpecial = sidePanelSpecialOptions.find((option) => option.selected);

    const mainbodySelected =
      mainbodyActiveTab === 'Satin' ? selectedMainbodySatin : selectedMainbodySpecial;

    const sidePanelSelected =
      sidePanelActiveTab === 'Satin' ? selectedSidePanelSatin : selectedSidePanelSpecial;

    return {
      waistband: waistbandOptions.find((option) => option.selected)?.name || '',
      trims: trimsOptions.find((option) => option.selected)?.name || '',
      mainbody: mainbodySelected?.name || '',
      sidePanel: sidePanelSelected?.name || '',
      selectedMainbodySatin,
      selectedMainbodySpecial,
      selectedSidePanelSatin,
      selectedSidePanelSpecial,
    };
  }, [optionsData, mainbodyActiveTab, sidePanelActiveTab]);

  useEffect(() => {
    if (!hasInitializedTabs) {
      // For Main Body
      const mainbodyAttributes = groups[2]?.attributes?.[0]?.options || [];
      const mainbodySatinSelected = mainbodyAttributes[0]?.selected;
      const mainbodySpecialSelected = mainbodyAttributes[1]?.selected;

      if (mainbodySpecialSelected) setMainbodyActiveTab('Special Fabrics');
      else if (mainbodySatinSelected) setMainbodyActiveTab('Satin');

      // For Side Panel
      const sidePanelAttributes = groups[3]?.attributes?.[0]?.options || [];
      const sidePanelSatinSelected = sidePanelAttributes[0]?.selected;
      const sidePanelSpecialSelected = sidePanelAttributes[1]?.selected;

      if (sidePanelSpecialSelected) setSidePanelActiveTab('Special Fabrics');
      else if (sidePanelSatinSelected) setSidePanelActiveTab('Satin');

      setHasInitializedTabs(true);
    }
  }, [groups, hasInitializedTabs]);

  const handleTabChange = useCallback(
    (tab: 'Satin' | 'Special Fabrics', isMainbody: boolean) => {
      const isActive = isMainbody ? mainbodyActiveTab === tab : sidePanelActiveTab === tab;
      if (isActive) return;
      const options = isMainbody
        ? tab === 'Satin'
          ? optionsData.mainbodySatinOptions
          : optionsData.mainbodySpecialOptions
        : tab === 'Satin'
          ? optionsData.sidePanelSatinOptions
          : optionsData.sidePanelSpecialOptions;

      const firstOption = options[0];
      const mockEvent = {
        preventDefault: () => {},
        stopPropagation: () => {},
      } as React.MouseEvent<HTMLElement>;

      onOptionClick(mockEvent, firstOption);
      isMainbody ? setMainbodyActiveTab(tab) : setSidePanelActiveTab(tab);
    },
    [mainbodyActiveTab, sidePanelActiveTab, optionsData, selectOption, setCamera]
  );

  const handleOptionClick = useCallback(
    (
      e: React.MouseEvent<HTMLElement>,
      option: Option,
      section: 'waistband' | 'mainbody' | 'sidepanel' | 'trims'
    ) => {
      e.stopPropagation();
      selectOption(option.id);
      onOptionClick(e, option);

      // Camera logic based on section
      const groupIndex = {
        waistband: 1,
        mainbody: 2,
        sidepanel: 2,
        trims: 3,
      }[section];

      const groupWithCamera = groups[groupIndex];
      if (groupWithCamera?.cameraLocationId) {
        setCamera(groupWithCamera.cameraLocationId);
      }
    },
    [selectOption, onOptionClick, groups, setCamera]
  );

  const renderOption = (
    option: Option,
    activeTab: string,
    section: 'waistband' | 'mainbody' | 'sidepanel' | 'trims'
  ) => {
    const pricing = option.pricings?.[0]?.price;

    return (
      <div key={option.id} className="special-fabric">
        <OptionItem option={option} onOptionClick={(e) => handleOptionClick(e, option, section)} />
        {activeTab === 'Special Fabrics' && (
          <div className="special-fabric-pricing">
            {typeof pricing === 'number' && pricing > 0 ? `+£${pricing.toFixed(2)}` : 'Free'}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="fabric-section">
      {optionsData.waistbandOptions.length > 0 && (
        <SubSection>
          <SubSectionTitle>
            <strong>Waistband</strong>
            {selectedOptions.waistband && `: ${selectedOptions.waistband}, SATIN`}
          </SubSectionTitle>
          <strong className="fabric-heading">SATIN</strong>
          <OptionContainer>
            {optionsData.waistbandOptions.map((option) =>
              renderOption(option, 'Satin Colors', 'waistband')
            )}
          </OptionContainer>
        </SubSection>
      )}

      {(optionsData.mainbodySatinOptions.length > 0 ||
        optionsData.mainbodySpecialOptions.length > 0) && (
        <SubSection>
          <span>
            <SubSectionTitle>
              <strong>Main Body</strong>
              {selectedOptions.mainbody &&
                `: ${selectedOptions.mainbody}, ${mainbodyActiveTab.toUpperCase()}`}
            </SubSectionTitle>
          </span>

          <span className="tab-align">
            <TabContainer>
              <Tab
                active={mainbodyActiveTab === 'Satin'}
                onClick={() => handleTabChange('Satin', true)}
              >
                <span
                  className="cursor"
                  onClick={() => selectOption(groups[2]?.attributes?.[0]?.options?.[0]?.id || 0)}
                >
                  SATIN
                </span>
              </Tab>
              <Tab
                active={mainbodyActiveTab === 'Special Fabrics'}
                onClick={() => handleTabChange('Special Fabrics', true)}
              >
                <span
                  className="cursor"
                  onClick={() => selectOption(groups[2]?.attributes?.[0]?.options?.[1]?.id || 0)}
                >
                  SPECIAL FABRIC
                </span>
              </Tab>
            </TabContainer>
          </span>
          <OptionContainer>
            {(mainbodyActiveTab === 'Satin'
              ? optionsData.mainbodySatinOptions
              : optionsData.mainbodySpecialOptions
            ).map((option) => renderOption(option, mainbodyActiveTab, 'mainbody'))}
          </OptionContainer>
        </SubSection>
      )}

      {(optionsData.sidePanelSatinOptions.length > 0 ||
        optionsData.sidePanelSpecialOptions.length > 0) && (
        <SubSection>
          <span>
            <SubSectionTitle>
              <strong>Side Panel</strong>
              {selectedOptions.sidePanel &&
                `: ${selectedOptions.sidePanel}, ${sidePanelActiveTab.toUpperCase()}`}
            </SubSectionTitle>
          </span>

          <span className="tab-align">
            <TabContainer>
              <Tab
                active={sidePanelActiveTab === 'Satin'}
                onClick={() => handleTabChange('Satin', false)}
              >
                <span
                  className="cursor"
                  onClick={() => selectOption(groups[3]?.attributes?.[0]?.options?.[0]?.id || 0)}
                >
                  SATIN
                </span>
              </Tab>
              <Tab
                active={sidePanelActiveTab === 'Special Fabrics'}
                onClick={() => handleTabChange('Special Fabrics', false)}
              >
                <span
                  className="cursor"
                  onClick={() => selectOption(groups[3]?.attributes?.[0]?.options?.[1]?.id || 0)}
                >
                  SPECIAL FABRIC
                </span>
              </Tab>
            </TabContainer>
          </span>

          <OptionContainer>
            {(sidePanelActiveTab === 'Satin'
              ? optionsData.sidePanelSatinOptions
              : optionsData.sidePanelSpecialOptions
            ).map((option) => renderOption(option, sidePanelActiveTab, 'sidepanel'))}
          </OptionContainer>
        </SubSection>
      )}

      {optionsData.trimsOptions.length > 0 && (
        <SubSection>
          <SubSectionTitle>
            <strong>Trim</strong>
            {selectedOptions.trims && `: ${selectedOptions.trims}, SATIN`}
          </SubSectionTitle>
          <strong className="fabric-heading">SATIN</strong>
          <OptionContainer>
            {optionsData.trimsOptions.map((option) =>
              renderOption(option, 'Satin Colors', 'trims')
            )}
          </OptionContainer>
        </SubSection>
      )}
    </div>
  );
};

const WaistbandEmbroiderySection: React.FC<{
  groups: Group[];
  onOptionClick: (mouseEvent: React.MouseEvent<HTMLElement>, option: Option) => void;
}> = ({ groups, onOptionClick }) => {
  const [selectedEmbroiderySections, setSelectedEmbroiderySections] = useState<{
    front: boolean;
    back: boolean;
  }>({
    front: false,
    back: false,
  });

  const { product, items, isAreaVisible } = useZakeke();

  const { setCamera, getPrintingMethodsRestrictions, setItemColor } = useZakeke();
  const [waistbandTextColor, setWaistbandTextColor] = useState<string>('');
  const [waistbandTextColorBack, setWaistbandTextColorBack] = useState<string>('');
  const [frontAreaId, setFrontAreaId] = useState<number>();
  const [backAreaId, setBackAreaId] = useState<number>();

  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;
    if (!product?.areas) return; // Wait until product is loaded
    const filteredAreas = product?.areas.filter((area) => isAreaVisible(area.id)) ?? [];
    const front = hasTextOrImageItemsInAreaByPlaceholder1(
      PLACEHOLDERS.FrontAreaKeyword,
      filteredAreas,
      items,
      false
    );
    const back = hasTextOrImageItemsInAreaByPlaceholder1(
      PLACEHOLDERS.BackAreaKeyword,
      filteredAreas,
      items,
      false
    );

    setSelectedEmbroiderySections({ front, back });
    initializedRef.current = true;
  }, [product, items]);

  function getSelectedOptionIndex(group: Group): number {
    const attribute = group.attributes?.[0];
    if (!attribute || !Array.isArray(attribute.options)) return -1;

    return attribute.options.findIndex((option) => option.selected === true);
  }

  const getEmbroideryStyleOptions = (
    group?: Group,
    hideNoCustomisation: boolean = false
  ): Option[] => {
    if (!group) return [];

    const embroiderySteps = group.steps?.filter((step) => {
      return P.contains(step.name, PLACEHOLDERS.WaistbandEmbroideryStyleKeyword);
    });
    if (!embroiderySteps?.length) return [];

    const selectedIndex = getSelectedOptionIndex(groups[0]); // Pass the group here
    // console.log(selectedIndex)
    const selectedStep = embroiderySteps[selectedIndex];
    if (!selectedStep) return [];

    let options =
      selectedStep?.attributes
        ?.find((attr) => attr.name.toLowerCase().includes('waistband embroidery'))
        ?.options?.filter((opt) => opt.enabled !== false) || [];

    if (hideNoCustomisation) {
      options = options.filter(
        (opt) =>
          !opt.name.toLowerCase().includes('no customisation') &&
          !opt.name.toLowerCase().includes('no customization')
      );
    }
    // console.log(options)
    return options;
  };

  const getEmbroideryColourOptions = (group?: Group, selectedStyle: string = ''): Option[] => {
    if (!group || selectedStyle.toLowerCase().includes('no customisation')) return [];

    const selectedStyleLower = selectedStyle.toLowerCase();
    let targetStep = null;

    if (selectedStyleLower.includes('standard')) {
      targetStep = group.steps?.find((step) => step.name.toLowerCase().includes('standard'));
    } else if (selectedStyleLower.includes('sparkle')) {
      targetStep = group.steps?.find((step) => step.name.toLowerCase().includes('sparkle'));
    } else if (selectedStyleLower.includes('crystal')) {
      targetStep = group.steps?.find((step) => step.name.toLowerCase().includes('crystal'));
    }
    if (!targetStep) {
      targetStep = group.steps?.find((step) =>
        P.contains(step.name, PLACEHOLDERS.StepEmbroideryColourKeyword)
      );
    }

    if (!targetStep) {
      return [];
    }

    if (selectedStyleLower.includes('crystal')) {
      const colorAttribute = targetStep.attributes?.find(
        (attr) =>
          attr.name.toLowerCase().includes('color') || attr.name.toLowerCase().includes('colour')
      );
      return colorAttribute?.options?.filter((opt) => opt.enabled !== false) || [];
    }

    const colourAttribute = targetStep.attributes?.find((attr) => {
      const attrName = attr.name.toLowerCase();

      if (selectedStyleLower.includes('standard') && attrName.includes('standard')) {
        return true;
      }

      if (selectedStyleLower.includes('sparkle') && attrName.includes('sparkle')) {
        return true;
      }

      return attrName.includes('colour') || attrName.includes('color');
    });

    return colourAttribute?.options?.filter((opt) => opt.enabled !== false) || [];
  };

  const getOutlineColourOptions = (group?: Group, selectedStyle: string = ''): Option[] => {
    if (!group || selectedStyle.toLowerCase().includes('no customisation')) return [];

    const selectedStyleLower = selectedStyle.toLowerCase();
    const hasOutline =
      selectedStyleLower.includes('outline') || selectedStyleLower.includes('crystal');
    if (!hasOutline) return [];

    let outlineOptions: Option[] = [];
    const embroideryType = selectedStyleLower.includes('standard')
      ? 'standard'
      : selectedStyleLower.includes('sparkle')
        ? 'sparkle'
        : selectedStyleLower.includes('crystal')
          ? 'crystal'
          : '';

    for (const step of group.steps || []) {
      for (const attribute of step.attributes || []) {
        const attrName = attribute.name.toLowerCase();

        if (!attrName.includes('outline')) continue;

        let isMatch = false;

        if (embroideryType === 'crystal') {
          isMatch = !attrName.includes('standard') && !attrName.includes('sparkle');
        } else {
          isMatch =
            (embroideryType === 'standard' && attrName.includes('standard')) ||
            (embroideryType === 'sparkle' && attrName.includes('sparkle')) ||
            (!attrName.includes('standard') && !attrName.includes('sparkle'));
        }

        if (isMatch) {
          outlineOptions = attribute.options?.filter((opt) => opt.enabled !== false) || [];
          if (outlineOptions.length > 0) break;
        }
      }
      if (outlineOptions.length > 0) break;
    }

    return outlineOptions;
  };

  const getCrystalOptions = (group?: Group, side = 'Front') => {
    if (!group) return [];

    // Step "Crystal"
    const crystalStep = group.steps?.find((step) => step.name.toLowerCase().includes('crystal'));
    if (!crystalStep) return [];

    const sideAttributes =
      crystalStep.attributes?.filter((attr) =>
        attr.name.toLowerCase().includes(side.toLowerCase())
      ) || [];
    let allOptions: any[] = [];
    sideAttributes.forEach((attr) => {
      const enabledOptions = attr.options?.filter((opt) => opt.enabled !== false) || [];
      allOptions = [...allOptions, ...enabledOptions];
    });

    return allOptions;
  };

  const getPriceText = (option: Option): string => {
    const price = option.pricings?.[0]?.price;
    return price && price > 0 ? `+£${price}` : '';
  };
  const getPriceTextWaist = (option: Option): string => {
    const price = option.pricings?.[0]?.price;
    if (!price || price === 0) {
      return '+£8';
    }
    return `+£${price + 8}`;
  };

  const handleStandardSelection = (group: Group | undefined, isSelected: boolean) => {
    if (!group || !isSelected) return;

    const options = getEmbroideryStyleOptions(group, true);

    const alreadySelected = options.find((opt) => opt.selected);
    if (alreadySelected) {
      return;
    }

    const standardOption = options[options.length - 1];

    if (standardOption) {
      const mockEvent = {
        preventDefault: () => {},
        stopPropagation: () => {},
      } as React.MouseEvent<HTMLElement>;
      onOptionClick(mockEvent, standardOption);
    }
  };

  const clearAllSelections = (group: Group | undefined) => {
    if (!group) return;

    const mockEvent = {
      preventDefault: () => {},
      stopPropagation: () => {},
    } as React.MouseEvent<HTMLElement>;

    const allStyleOptions = getEmbroideryStyleOptions(group, false); // Don't hide no customisation
    const noCustomisationOption = allStyleOptions.find(
      (opt) =>
        opt.name.toLowerCase().includes('no customisation') ||
        opt.name.toLowerCase().includes('no customization')
    );

    if (noCustomisationOption && !noCustomisationOption.selected) {
      onOptionClick(mockEvent, noCustomisationOption);
      return;
    }

    const allSelectedOptions: Option[] = [];

    group.steps?.forEach((step) => {
      step.attributes?.forEach((attr) => {
        attr.options?.forEach((opt) => {
          if (opt.selected) {
            allSelectedOptions.push(opt);
          }
        });
      });
    });

    // Deselect all selected options
    allSelectedOptions.forEach((option) => {
      onOptionClick(mockEvent, option);
    });
  };

  const frontGroup = groups.find((g) => P.contains(g.name, PLACEHOLDERS.FrontAreaKeyword));
  const backGroup = groups.find((g) => P.contains(g.name, PLACEHOLDERS.BackAreaKeyword));

  const frontOptions = getEmbroideryStyleOptions(frontGroup, selectedEmbroiderySections.front);
  const backOptions = getEmbroideryStyleOptions(backGroup, selectedEmbroiderySections.back);

  const selectedFront = frontOptions.find((o) => o.selected)?.name || '';
  const selectedBack = backOptions.find((o) => o.selected)?.name || '';

  const frontColours = getEmbroideryColourOptions(frontGroup, selectedFront);
  const backColours = getEmbroideryColourOptions(backGroup, selectedBack);

  const frontOutlines = getOutlineColourOptions(frontGroup, selectedFront);
  const backOutlines = getOutlineColourOptions(backGroup, selectedBack);

  const frontCrystals = getCrystalOptions(frontGroup, 'Front Crystal Waistband Crystal Colour');

  const backCrystals = getCrystalOptions(backGroup, 'Back Crystal Waistband Crystal Colour');

  const handleCheckboxChange = (type: 'front' | 'back') => {
    setSelectedEmbroiderySections((prev) => {
      const next = { ...prev };
      if (type === 'front') {
        next.front = !prev.front;
        if (next.front) {
          handleStandardSelection(frontGroup, true);
        } else {
          removeItems(frontAreaId);
          clearAllSelections(frontGroup);
        }
      } else {
        next.back = !prev.back;
        if (next.back) {
          handleStandardSelection(backGroup, true);
        } else {
          removeItems(backAreaId);
          clearAllSelections(backGroup);
        }
      }
      return next;
    });
  };

  useEffect(() => {
    if (!product?.areas) return;
    const filteredAreas = product?.areas.filter((area) => isAreaVisible(area.id)) ?? [];

    const front = hasTextOrImageItemsInAreaByPlaceholder(
      PLACEHOLDERS.FrontAreaKeyword,
      filteredAreas,
      items
    );
    const back = hasTextOrImageItemsInAreaByPlaceholder(
      PLACEHOLDERS.BackAreaKeyword,
      filteredAreas,
      items
    );
    if (front) {
      setCustomizeTab(true);
    } else {
      setCustomizeTab(false);
    }
    if (back) {
      setCustomizeTabBack(true);
    } else {
      setCustomizeTabBack(false);
    }
  }, [items, product]);
  const AddTextFrontWaistband = (isAdd: boolean) => {
    if (!frontOptions || frontOptions.length < 2) return;

    const mockEvent = {
      preventDefault: () => {},
      stopPropagation: () => {},
    } as unknown as React.MouseEvent<HTMLElement>;

    // If isAdd is true, pick the last option; otherwise, pick the second option.
    const optionToClick = isAdd ? frontOptions[frontOptions.length - 1] : frontOptions[0];

    onOptionClick(mockEvent, optionToClick);
  };
  const BackTextFrontWaistband = (isAdd: boolean) => {
    if (!backOptions || backOptions.length < 2) return;

    const mockEvent = {
      preventDefault: () => {},
      stopPropagation: () => {},
    } as unknown as React.MouseEvent<HTMLElement>;

    // If isAdd is true, pick the last option; otherwise, pick the second option.
    const optionToClick = isAdd ? backOptions[backOptions.length - 1] : backOptions[0];

    onOptionClick(mockEvent, optionToClick);
  };

  const renderOptionWithPrice = (option: Option, key: string) => (
    <div key={key} className="option-price">
      <OptionItem option={option} onOptionClick={onOptionClick} isStyle={false} />
      <div className="waistband-price">{getPriceText(option)}</div>
    </div>
  );

  // console.log(waistbandTextColor)

  const renderColorOption = (option: Option, key: string) => (
    <div key={key} className="option-price" onClick={() => setWaistbandTextColor(option.name)}>
      <OptionItem option={option} onOptionClick={onOptionClick} isStyle={false} />
      <div className="waistband-price">{getPriceText(option)}</div>
    </div>
  );
  const renderBackColorOption = (option: Option, key: string) => (
    <div key={key} className="option-price" onClick={() => setWaistbandTextColorBack(option.name)}>
      <OptionItem option={option} onOptionClick={onOptionClick} isStyle={false} />
      <div className="waistband-price">{getPriceText(option)}</div>
    </div>
  );

  const renderMainOptions = (option: Option, key: string) => (
    <div key={key} className="option-price" onClick={() => HandleColorClick('front')}>
      <OptionItem option={option} onOptionClick={onOptionClick} isWaist={true} />
      <div className="waistband-price">{getPriceTextWaist(option)}</div>
    </div>
  );

  const renderMainBackOptions = (option: Option, key: string) => (
    <div key={key} className="option-price" onClick={() => HandleColorClick('back')}>
      <OptionItem option={option} onOptionClick={onOptionClick} isWaist={true} />
      <div className="waistband-price">{getPriceTextWaist(option)}</div>
    </div>
  );
  const HandleColorClick = (side: string) => {
    const mockEvent = {
      preventDefault: () => {},
      stopPropagation: () => {},
    } as unknown as React.MouseEvent<HTMLElement>;

    if (side === 'front') {
      onOptionClick(mockEvent, frontColours[0]);
      setWaistbandTextColor('black');
    } else if (side === 'back') {
      onOptionClick(mockEvent, backColours[0]);
      setWaistbandTextColorBack('black');
    }
  };

  // Updated price calculation logic to only show prices when checkbox is checked and not "no customisation"
  const selectedFrontOption = frontOptions.find((opt) => opt.selected);
  const selectedFrontPrice = selectedFrontOption?.pricings?.[0]?.price || 0;
  const formattedFrontPrice =
    selectedEmbroiderySections.front && // Only show if checkbox is checked
    selectedFrontOption &&
    selectedFrontOption.name.toLowerCase() !== 'no customisation' &&
    selectedFrontOption.name.toLowerCase() !== 'no customization' &&
    selectedFrontPrice > 0
      ? `+£${selectedFrontPrice}`
      : '';

  const selectedBackOption = backOptions.find((opt) => opt.selected);
  const selectedBackPrice = selectedBackOption?.pricings?.[0]?.price || 0;
  const formattedBackPrice =
    selectedEmbroiderySections.back && // Only show if checkbox is checked
    selectedBackOption &&
    selectedBackOption.name.toLowerCase() !== 'no customisation' &&
    selectedBackOption.name.toLowerCase() !== 'no customization' &&
    selectedBackPrice > 0
      ? `+£${selectedBackPrice}`
      : '';
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [customizeTab, setCustomizeTab] = useState(false);
  const [customizeTabBack, setCustomizeTabBack] = useState(false);

  useEffect(() => {
    // FRONT
    if (customizeTab) {
      const options = getEmbroideryStyleOptions(frontGroup, true);
      const alreadySelected = options.slice(0, -1).find((opt) => opt.selected);

      const standardOption = alreadySelected?.selected ? alreadySelected : options[0];
      if (standardOption) {
        const mockEvent = {
          preventDefault: () => {},
          stopPropagation: () => {},
        } as React.MouseEvent<HTMLElement>;

        onOptionClick(mockEvent, standardOption);
      }
    }

    if (customizeTabBack) {
      const options = getEmbroideryStyleOptions(backGroup, true);
      const alreadySelected = options.slice(0, -1).find((opt) => opt.selected);

      const standardOption = alreadySelected?.selected ? alreadySelected : options[0];
      if (standardOption) {
        const mockEvent = {
          preventDefault: () => {},
          stopPropagation: () => {},
        } as React.MouseEvent<HTMLElement>;

        onOptionClick(mockEvent, standardOption);
      }
    }
  }, [customizeTab, customizeTabBack]);
  useEffect(() => {
    if (!customizeTab) return;

    const alreadySelectedTextColor = frontColours.find((opt) => opt.selected)?.name;
    if (alreadySelectedTextColor) {
      setWaistbandTextColor(alreadySelectedTextColor);
    }
  }, [customizeTab]);

  useEffect(() => {
    if (!customizeTabBack) return;
    const alreadySelectedTextColor = backColours.find((opt) => opt.selected)?.name;
    if (alreadySelectedTextColor) {
      setWaistbandTextColorBack(alreadySelectedTextColor);
    }
  }, [customizeTabBack]);

  const restrictions = getPrintingMethodsRestrictions?.();
  return (
    <div>
      <SubSection>
        <div
          onClick={() => {
            handleCheckboxChange('front');
            if (frontGroup?.cameraLocationId) {
              setCamera(frontGroup.cameraLocationId);
            }
          }}
          className="camera-div"
        >
          <input type="checkbox" checked={selectedEmbroiderySections.front} className="check-box" />
          <span className="waist-band-heading">
            <span> ADD FRONT WAISTBAND EMBROIDERY</span>
          </span>
        </div>

        {selectedEmbroiderySections.front && (
          <>
            {selectedFront && !selectedFront.toLowerCase().includes('no customisation') && (
              <Designer
                placeholder={PLACEHOLDERS.FrontAreaKeyword}
                setCustomizeTab={setCustomizeTab}
                waistbandTextColor={waistbandTextColor}
                TextWaistbandController={AddTextFrontWaistband}
                setAreaId={setFrontAreaId}
              />
            )}

            {customizeTab && (
              <>
                <SubSectionTitle>
                  <strong>Embroidery Style</strong>
                  {`: ${selectedFront || 'Select Embroidery Style'}`}
                </SubSectionTitle>

                <OptionContainer>
                  {frontOptions
                    ?.slice(0, -1)
                    .map((opt) => renderMainOptions(opt, `front-style-${opt.id}`))}
                </OptionContainer>

                {selectedFront && !selectedFront.toLowerCase().includes('no customisation') && (
                  <>
                    <SubSubSectionTitle>
                      <strong>Color</strong>
                    </SubSubSectionTitle>
                    <SubSubSectionTitle>
                      <strong className="waist-band-subheading">Selected Color : </strong>
                      <span className="waist-band-subheading-color">
                        {frontColours.find((opt) => opt.selected)?.name
                          ? `${frontColours.find((opt) => opt.selected)?.name}`
                          : 'No outline selected'}
                      </span>
                    </SubSubSectionTitle>
                    <OptionContainer>
                      {frontColours.map((opt) => renderColorOption(opt, `front-colour-${opt.id}`))}
                    </OptionContainer>

                    {frontOutlines.length > 0 && (
                      <>
                        <SubSubSectionTitle>
                          <strong>Outline</strong>
                        </SubSubSectionTitle>
                        <SubSubSectionTitle>
                          <strong className="waist-band-subheading">Selected Outline : </strong>
                          <span className="waist-band-subheading-color">
                            {frontOutlines.find((opt) => opt.selected)?.name
                              ? `${frontOutlines.find((opt) => opt.selected)?.name}`
                              : 'No outline selected'}
                          </span>
                        </SubSubSectionTitle>
                        <span className="waist-band-note">
                          <strong>Please note:</strong> These styles will not be applied to the 3D
                          model.
                        </span>
                        <OptionContainer>
                          {frontOutlines.map((opt) =>
                            renderOptionWithPrice(opt, `front-outline-${opt.id}`)
                          )}
                        </OptionContainer>
                      </>
                    )}

                    {selectedFront.toLowerCase().includes('crystal') &&
                      frontCrystals.length > 0 && (
                        <>
                          <SubSubSectionTitle>
                            <strong>Crystal</strong>
                          </SubSubSectionTitle>
                          <SubSubSectionTitle>
                            <strong className="waist-band-subheading">Selected Crystal : </strong>
                            <span className="waist-band-subheading-color">
                              {frontCrystals.find((opt) => opt.selected)?.name
                                ? `${frontCrystals.find((opt) => opt.selected)?.name}`
                                : 'No crystal selected'}
                            </span>
                          </SubSubSectionTitle>
                          <span className="waist-band-note">
                            <strong>Please note:</strong> These styles will not be applied to the 3D
                            model.
                          </span>
                          <OptionContainer>
                            {frontCrystals.map((opt) =>
                              renderOptionWithPrice(opt, `front-crystal-${opt.id}`)
                            )}
                          </OptionContainer>
                        </>
                      )}
                  </>
                )}
              </>
            )}
          </>
        )}
        <div
          onClick={() => {
            handleCheckboxChange('back');
            if (frontGroup?.cameraLocationId) {
              setCamera(frontGroup.cameraLocationId);
            }
          }}
          className="camera-div"
        >
          <input type="checkbox" checked={selectedEmbroiderySections.back} className="check-box" />
          <span className="waist-band-heading">
            <span>ADD BACK WAISTBAND EMBROIDERY</span>
          </span>
        </div>

        {selectedEmbroiderySections.back && (
          <>
            {selectedBack && !selectedBack.toLowerCase().includes('no customisation') && (
              <Designer
                placeholder={PLACEHOLDERS.BackAreaKeyword}
                setCustomizeTab={setCustomizeTabBack}
                waistbandTextColorBack={waistbandTextColorBack}
                setAreaId={setBackAreaId}
                TextWaistbandController={BackTextFrontWaistband}
              />
            )}

            {customizeTabBack && (
              <>
                <SubSectionTitle>
                  <strong>Embroidery Style</strong>
                  {`: ${selectedBack || 'Select Embroidery Style'}`}
                </SubSectionTitle>

                <OptionContainer>
                  {backOptions
                    ?.slice(0, -1)
                    .map((opt) => renderMainBackOptions(opt, `back-style-${opt.id}`))}
                </OptionContainer>

                {selectedBack && !selectedBack.toLowerCase().includes('no customisation') && (
                  <>
                    <SubSubSectionTitle>
                      <strong>Color</strong>
                    </SubSubSectionTitle>
                    <SubSubSectionTitle>
                      <strong>Selected Color : </strong>
                      <span className="waist-band-subheading-color">
                        {backColours.find((opt) => opt.selected)?.name
                          ? `${backColours.find((opt) => opt.selected)?.name}`
                          : 'No outline selected'}
                      </span>
                    </SubSubSectionTitle>
                    <OptionContainer>
                      {backColours.map((opt) =>
                        renderBackColorOption(opt, `back-colour-${opt.id}`)
                      )}
                    </OptionContainer>

                    {backOutlines.length > 0 && (
                      <>
                        <SubSubSectionTitle>
                          <strong>Outline</strong>
                        </SubSubSectionTitle>
                        <SubSubSectionTitle>
                          <strong>Selected Outline : </strong>
                          <span className="waist-band-subheading-color">
                            {backOutlines.find((opt) => opt.selected)?.name
                              ? `${backOutlines.find((opt) => opt.selected)?.name}`
                              : 'No outline selected'}
                          </span>
                        </SubSubSectionTitle>
                        <span className="waist-band-note">
                          <strong>Please note:</strong> These styles will not be applied to the 3D
                          model.
                        </span>
                        <OptionContainer>
                          {backOutlines.map((opt) =>
                            renderOptionWithPrice(opt, `back-outline-${opt.id}`)
                          )}
                        </OptionContainer>
                      </>
                    )}

                    {selectedBack.toLowerCase().includes('crystal') && backCrystals.length > 0 && (
                      <>
                        <SubSubSectionTitle>
                          <strong>Crystal Type</strong>
                        </SubSubSectionTitle>
                        <SubSubSectionTitle>
                          <strong>Selected Crystal : </strong>
                          <span className="waist-band-subheading-color">
                            {backCrystals.find((opt) => opt.selected)?.name
                              ? `${backCrystals.find((opt) => opt.selected)?.name}`
                              : 'No crystal selected'}
                          </span>
                        </SubSubSectionTitle>
                        <OptionContainer>
                          {backCrystals.map((opt) =>
                            renderOptionWithPrice(opt, `back-crystal-${opt.id}`)
                          )}
                        </OptionContainer>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </SubSection>
    </div>
  );
};

const DirectOptionsSection: React.FC<{
  options: Option[];
  onOptionClick: (mouseEvent: React.MouseEvent<HTMLElement>, option: Option) => void;
  title?: string;
  description?: string;
}> = ({ options, onOptionClick, title, description }) => {
  const selectedOption = options.find((option) => option.selected)?.name || '';
  const { product, items } = useZakeke();

  const [selectedCheckbox, setSelectedCheckbox] = useState<null | string>(null);
  const [sectionPrices, setSectionPrices] = useState<{ [key: string]: number }>({});

  const [sectionPrices1, setSectionPrices1] = useState<{
    [key: string]: number;
  }>({
    frontRight: 0,
    frontLeft: 0,
    backRight: 0,
    backLeft: 0,
  });

  const handleCheckboxChange = (key: string) => {
    setSelectedCheckbox((prev) => (prev === key ? null : key));
  };

  const handlePriceChange = (key: string, price: number) => {
    setSectionPrices((prev) => ({ ...prev, [key]: price }));
  };

  return (
    <div>
      <SubSection>
        <SubSubSectionTitle>
          <strong>Please note</strong>: Right and Left sides are from the person's perspective who
          is wearing the garment
        </SubSubSectionTitle>
      </SubSection>
      {title && (
        <SubSection>
          <label className="embelisment">
            <span onClick={() => handleCheckboxChange('frontRight')} className="waist-band-heading">
              <span className="embelisment-heading">ADD FRONT RIGHT LEG EMBELLISHMENT</span>

              <SvgArrowDownBlack1
                style={{
                  transform: selectedCheckbox === 'frontRight' ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                className="arrow-icon svg-css"
              />
            </span>
          </label>
          {selectedCheckbox === 'frontRight' && (
            <Designer
              placeholder={PLACEHOLDERS.FrontRightLegKeyword}
              onPriceChange={(price) => handlePriceChange('frontRight', price)}
            />
          )}
          <label className="embelisment">
            <span onClick={() => handleCheckboxChange('frontLeft')} className="waist-band-heading">
              <span className="embelisment-heading">ADD FRONT LEFT LEG EMBELLISHMENT</span>
              <SvgArrowDownBlack1
                style={{
                  transform: selectedCheckbox === 'frontLeft' ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                className="arrow-icon svg-css"
              />
            </span>
          </label>
          {selectedCheckbox === 'frontLeft' && (
            <Designer
              placeholder={PLACEHOLDERS.FrontLeftLegKeyword}
              onPriceChange={(price) => handlePriceChange('frontLeft', price)}
            />
          )}

          <label className="embelisment">
            <span onClick={() => handleCheckboxChange('backRight')} className="waist-band-heading">
              <span className="embelisment-heading">ADD BACK RIGHT LEG EMBELLISHMENT</span>
              <SvgArrowDownBlack1
                style={{
                  transform: selectedCheckbox === 'backRight' ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                className="arrow-icon svg-css"
              />
            </span>
          </label>
          {selectedCheckbox === 'backRight' && (
            <Designer
              placeholder={PLACEHOLDERS.BackRightLegKeyword}
              onPriceChange={(price) => handlePriceChange('backRight', price)}
            />
          )}

          <label className="embelisment">
            <span onClick={() => handleCheckboxChange('backLeft')} className="waist-band-heading">
              <span className="embelisment-heading">ADD BACK LEFT LEG EMBELLISHMENT</span>
              <SvgArrowDownBlack1
                style={{
                  transform: selectedCheckbox === 'backLeft' ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                className="arrow-icon svg-css"
              />
            </span>
          </label>
          {selectedCheckbox === 'backLeft' && (
            <Designer
              placeholder={PLACEHOLDERS.BackLeftLegKeyword}
              onPriceChange={(price) => handlePriceChange('backLeft', price)}
            />
          )}
        </SubSection>
      )}
    </div>
  );
};

const Selector: FunctionComponent<SelectorProps> = ({ refViewer, fullScreen }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const {
    setIsUndo,
    setIsRedo,
    priceFormatter,
    undoStack,
    isRedo,
    isUndo,
    redoStack,
    setSelectedGroupId,
    setSelectedStepId,
    setSelectedAttributeId,
    isMobile,
    selectedGroupId,
    selectedAttributeId,
    selectedStepId,
    setLastSelectedItem,
    setSelectedTemplateGroupId,
    setIsPDStartedFromCart,
    pdValue,
    setTryOnMode,
    tryOnRef,
    isDraftEditor,
    isEditorMode,
  } = useStore();
  const {
    isSceneLoading,
    useLegacyScreenshot,
    groups,
    addToCart,
    selectOption,
    setCamera,
    setCameraByName,
    setExplodedMode,
    zoomIn,
    zoomOut,
    IS_IOS,
    redo,
    undo,
    sellerSettings,
    productName,
    price,
    isOutOfStock,
    getOnlineScreenshot,
    setQuantity,
    nftSettings,
    product,
    isMandatoryPD,
    eventMessages,
    quantity,
  } = useZakeke();

  const undoRegistering = useUndoRegister();
  const undoRedoActions = useUndoRedoActions();
  const { showDialog, closeDialog } = useDialogManager();
  const [lastSelectedSteps, setLastSelectedSteps] = useState(new Map<number, number>());
  const [selectedCarouselSlide, setSelectedCarouselSlide] = useState<number>(0);
  const [attributesOpened, setAttributesOpened] = useState<Map<number, boolean>>(new Map());

  const idsToRemove = [-1];
  const visibleGroups: Group[] = groups.filter((obj: Group) => !idsToRemove.includes(obj.id));

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isRecapPanelOpened, setRecapPanelOpened] = useState(
    sellerSettings?.isCompositionRecapVisibleFromStart ?? false
  );
  const [selectedCameraID, setSelectedCameraID] = useState<string | null>(null);
  const [previewImage, setPreviewImage] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checkOnce, setCheckOnce] = useState<boolean>(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [resetCameraID, setResetCameraID] = useState<string | null>(null);
  const [mountingSelectedOption, setMountingSelectedOption] = useState<string | null>('None');
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const viewFooter = useRef<HTMLDivElement | null>(null);
  const [selectedSize, setSelectedSize] = useState('M');
  const [openGroup, setOpenGroup] = useState<number | null>(null);
  const actualGroups = useActualGroups() ?? [];
  const [isStartRegistering, setIsStartRegistering] = useState(false);
  const [lastSelectedItemsFromSteps, setLastSelectedItemFromSteps] = useState(
    new Map<number, [number, string]>()
  );
  const [lastSelectedItemsFromGroups, setLastSelectedItemsFromGroups] = useState(
    new Map<number, [number, string]>()
  );
  const [quantityValue, setQuantityValue] = useState(
    product?.quantityRule && product.quantityRule?.minQuantity
      ? product.quantityRule.minQuantity
      : quantity
  );

  const selectedGroup = selectedGroupId
    ? actualGroups.find((group) => group.id === selectedGroupId)
    : null;
  const selectedStep = selectedGroupId
    ? actualGroups
        .find((group) => group.id === selectedGroupId)
        ?.steps.find((step) => step.id === selectedStepId)
    : null;
  const currentAttributes = selectedStep
    ? selectedStep.attributes
    : selectedGroup
      ? selectedGroup.attributes
      : [];
  const currentTemplateGroups = selectedStep
    ? selectedStep.templateGroups
    : selectedGroup
      ? selectedGroup.templateGroups
      : [];

  const currentItems = [...currentAttributes, ...currentTemplateGroups].sort(
    (a, b) => a.displayOrder - b.displayOrder
  );
  const selectedAttribute = currentAttributes
    ? currentAttributes.find((attr) => attr.id === selectedAttributeId)
    : null;

  const hasLogged = useRef(false);

  const handleStepSelection = (stepId: number | null) => {
    setIsStartRegistering(undoRegistering.startRegistering());

    if (selectedStepId !== stepId && !isUndo && !isRedo) {
      undoRedoActions.eraseRedoStack();
      undoRedoActions.fillUndoStack({
        type: 'step',
        id: selectedStepId,
        direction: 'undo',
      });
      undoRedoActions.fillUndoStack({
        type: 'step',
        id: stepId ?? null,
        direction: 'redo',
      });
    }

    setSelectedStepId(stepId);

    const newStepSelected = lastSelectedSteps.set(selectedGroupId!, stepId!);
    setLastSelectedSteps(newStepSelected);
  };
  // Reset attribute selection when group selection changes
  useEffect(() => {
    if (selectedGroup && selectedGroup.id !== -2) {
      if (selectedGroup.steps.length > 0) {
        if (
          lastSelectedSteps.get(selectedGroupId!) &&
          selectedGroup.steps.find((step) => step.id === lastSelectedSteps.get(selectedGroupId!)!)
        )
          handleStepSelection(lastSelectedSteps.get(selectedGroupId!)!);
        else handleStepSelection(selectedGroup.steps[0].id);
      } else {
        handleStepSelection(null);
      }

      setSelectedCarouselSlide(0);

      if (!actualGroups.find((group) => group.id === selectedGroupId)!.attributesAlwaysOpened) {
        let attributes: Attribute[] = [];
        let group = actualGroups.find((group) => group.id === selectedGroupId)!;
        if (group.attributes.length > 0) {
          attributes.push(group.attributes[0]);
        }
        if (group.steps.length > 0) {
          let stepsFirstAttributes = group.steps.map((step) => {
            if (step.attributes.length > 0) {
              return step.attributes[0];
            } else return null;
          });
          stepsFirstAttributes.forEach((attribute) => {
            if (attribute) attributes.push(attribute);
          });
        }
        if (attributes && attributes.length > 0) {
          // Add attributes in openedAttributes and set isOpened to true if already exists
          setAttributesOpened((prev) => {
            attributes.forEach((attribute) => {
              prev = prev.set(attribute.id, true);
            });

            return prev;
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroupId, selectedGroup?.steps.length]);

  const handleAttributeSelection = (attributeId: number, isAttributesVertical?: boolean) => {
    setIsStartRegistering(undoRegistering.startRegistering());

    if (attributeId && selectedAttributeId !== attributeId && !isUndo && !isRedo) {
      undoRedoActions.eraseRedoStack();
      undoRedoActions.fillUndoStack({
        type: 'attribute',
        id: selectedAttributeId,
        direction: 'undo',
      });
      undoRedoActions.fillUndoStack({
        type: 'attribute',
        id: attributeId,
        direction: 'redo',
      });
    }

    setSelectedAttributeId(attributeId);

    if (isAttributesVertical && !selectedGroup?.attributesAlwaysOpened) {
      setAttributesOpened(attributesOpened.set(attributeId, !attributesOpened.get(attributeId)));
    }

    if (selectedStep && selectedStep.attributes.find((attr) => attr.id === attributeId)) {
      const newLastAttributeSelected = lastSelectedItemsFromSteps.set(selectedStepId!, [
        attributeId,
        'attribute',
      ]);
      setLastSelectedItemFromSteps(newLastAttributeSelected);
    } else {
      const newLastAttributeSelected = lastSelectedItemsFromGroups.set(selectedGroupId!, [
        attributeId,
        'attribute',
      ]);
      setLastSelectedItemsFromGroups(newLastAttributeSelected);
    }
    setLastSelectedItem({ type: 'attribute', id: attributeId });
  };

  const handleTemplateGroupSelection = (templateGroupId: number, isTemplateVertical?: boolean) => {
    setSelectedTemplateGroupId(templateGroupId);
    setLastSelectedItem({ type: 'template-group', id: templateGroupId });
    if (isTemplateVertical && !selectedGroup?.attributesAlwaysOpened) {
      setAttributesOpened(
        attributesOpened.set(templateGroupId, !attributesOpened.get(templateGroupId))
      );
    }
    if (
      selectedStep &&
      selectedStep.templateGroups.find((templGr) => templGr.templateGroupID === templateGroupId)
    ) {
      const newLastTemplateGroupSelected = lastSelectedItemsFromSteps.set(selectedStepId!, [
        templateGroupId,
        'template group',
      ]);
      setLastSelectedItemFromSteps(newLastTemplateGroupSelected);
    } else {
      const newLastItemSelected = lastSelectedItemsFromGroups.set(selectedGroupId!, [
        templateGroupId,
        'template group',
      ]);
      setLastSelectedItemsFromGroups(newLastItemSelected);
    }
  };
  // select an attribute if selected step or group change
  useEffect(() => {
    if (selectedStep && currentItems.length > 0) {
      if (
        lastSelectedItemsFromSteps &&
        selectedStepId &&
        lastSelectedItemsFromSteps.get(selectedStepId!)
      ) {
        const selectedItem = lastSelectedItemsFromSteps.get(selectedStepId!);
        if (selectedItem && selectedItem[1] === 'attribute') {
          if (selectedStep.attributes.some((attr) => attr.id === selectedItem[0]))
            handleAttributeSelection(lastSelectedItemsFromSteps!.get(selectedStepId!)![0]!);
          else handleAttributeSelection(selectedStep.attributes[0].id);
        }
        if (selectedItem && selectedItem[1] === 'template group') {
          if (
            selectedStep.templateGroups.some(
              (templGr) => templGr.templateGroupID === selectedItem[0]
            )
          )
            handleTemplateGroupSelection(lastSelectedItemsFromSteps!.get(selectedStepId!)![0]!);
          else handleTemplateGroupSelection(selectedStep.templateGroups[0].templateGroupID);
        }
      } else {
        if (!(currentItems[0] instanceof ThemeTemplateGroup))
          handleAttributeSelection(currentItems[0].id);
        else handleTemplateGroupSelection(currentItems[0].templateGroupID);
      }
    } else if (selectedGroup && currentItems.length > 0) {
      if (
        lastSelectedItemsFromSteps &&
        selectedGroupId &&
        lastSelectedItemsFromGroups.get(selectedGroupId)
      ) {
        const selectedItem = lastSelectedItemsFromGroups.get(selectedGroupId);
        if (selectedItem && selectedItem[1] === 'attribute') {
          const attributeToBeAutoSelected = selectedGroup.attributes.find(
            (attr) => attr.id === selectedItem[0]
          );
          // fix check if enabled in case of attributes with link
          if (attributeToBeAutoSelected && attributeToBeAutoSelected.enabled)
            handleAttributeSelection(lastSelectedItemsFromGroups!.get(selectedGroupId!)![0]!);
          else if (selectedGroup && selectedGroup.attributes.length > 0)
            handleAttributeSelection(selectedGroup.attributes[0].id);
        }
        if (selectedItem && selectedItem[1] === 'template group') {
          if (
            selectedGroup.templateGroups.some(
              (templGr) => templGr.templateGroupID === selectedItem[0]
            )
          )
            handleTemplateGroupSelection(lastSelectedItemsFromGroups!.get(selectedGroupId!)![0]!);
        }
      } else {
        if (!(currentItems[0] instanceof ThemeTemplateGroup))
          handleAttributeSelection(selectedGroup.attributes[0].id);
        else handleTemplateGroupSelection(currentItems[0].templateGroupID);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStepId, selectedGroupId]);
  const getSelectedOptions = useCallback((group: Group): Option[] => {
    return (
      group.attributes
        ?.flatMap(
          (attr) =>
            attr?.options?.filter(
              (option: Option) => option && option.selected && option.enabled
            ) || []
        )
        .filter((option): option is any => option !== undefined) || []
    );
  }, []);

  useEffect(() => {
    if (visibleGroups.length > 0 && !hasLogged.current) {
      visibleGroups.forEach((group: Group, index: number) => {
        if (group.attributes && group.attributes.length > 0) {
          group.attributes.forEach((attr, attrIndex) => {
            if (attr?.options && attr.options.length > 0) {
              attr.options.forEach((option, optIndex) => {});
            } else {
              console.log('No options available for this attribute.');
            }
            console.groupEnd();
          });
        } else {
          console.log('No attributes available for this group.');
        }

        if (group.steps && group.steps.length > 0) {
          group.steps.forEach((step, stepIndex) => {
            if (step.attributes && step.attributes.length > 0) {
              step.attributes.forEach((attr, attrIndex) => {
                if (attr?.options && attr.options.length > 0) {
                  attr.options.forEach((option, optIndex) => {});
                }
                console.groupEnd();
              });
            }
            console.groupEnd();
          });
        }
        console.groupEnd();
      });
      console.log('=== END OF GROUPS ===\n');
      hasLogged.current = true;
    } else if (visibleGroups.length === 0) {
      console.log('No groups available.');
    }
  }, [visibleGroups]);

  useEffect(() => {
    if (sellerSettings?.isCompositionRecapVisibleFromStart) {
      setRecapPanelOpened(sellerSettings.isCompositionRecapVisibleFromStart);
    }
  }, [sellerSettings]);

  useEffect(() => {
    if (!isSceneLoading && visibleGroups.length > 0 && visibleGroups[0].cameraLocationId) {
      setCamera(visibleGroups[0].cameraLocationId);
    }
  }, [isSceneLoading]);

  const handleOptionClick = useCallback(
    (mouseEvent: React.MouseEvent<HTMLElement>, option: Option) => {
      if (!option || typeof option.id === 'undefined') {
        // console.error("Invalid option clicked:", option);
        return;
      }
      const selectedOptionId: number | null =
        selectedAttribute?.options.find((opt) => opt.selected)?.id ?? null;

      const undo = undoRegistering.startRegistering();
      undoRedoActions.eraseRedoStack();
      undoRedoActions.fillUndoStack({ type: 'option', id: selectedOptionId, direction: 'undo' });
      undoRedoActions.fillUndoStack({ type: 'option', id: option.id, direction: 'redo' });

      selectOption(option.id);
      undoRegistering.endRegistering(undo);
      setMountingSelectedOption(option.name);
      selectOption(option.id);
      if (option.cameraLocationId) {
        setCamera(option.cameraLocationId);
      }
      setForceUpdate((prev) => !prev);
      try {
        if ((window as any).algho) (window as any).algho.sendUserStopForm(true);
      } catch (e) {}
    },
    [selectOption, setCamera]
  );

  const handleGroupClick = useCallback(
    (group: Group, index: number) => {
      setIsStartRegistering(undoRegistering.startRegistering());

      if (group.id && selectedGroupId !== group.id && !isUndo && !isRedo) {
        undoRedoActions.eraseRedoStack();
        undoRedoActions.fillUndoStack({
          type: 'group',
          id: selectedGroupId,
          direction: 'undo',
        });
        undoRedoActions.fillUndoStack({
          type: 'group',
          id: group.id ?? null,
          direction: 'redo',
        });
      }
      setSelectedGroupId(group.id);
      let cameraGroup = group;

      if (openGroup === index && visibleGroups.length > 0) {
        const firstGroup = visibleGroups[0];
        if (firstGroup?.cameraLocationId) {
          setCamera(firstGroup.cameraLocationId);
        }
      } else {
        if (index === 1 && visibleGroups.length >= 1) {
          cameraGroup = visibleGroups[2];
        } else if (index === 2 && visibleGroups.length >= 4) {
          cameraGroup = visibleGroups[1];
        } else if (index === 3 && visibleGroups.length >= 4) {
          cameraGroup = visibleGroups[0];
        }

        if (cameraGroup?.cameraLocationId) {
          setCamera(cameraGroup.cameraLocationId);
        }
      }

      setOpenGroup((prev) => (prev === index ? null : index));
    },
    [setCamera, visibleGroups, openGroup]
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (selectedCameraID) {
      setCamera(selectedCameraID);
      setSelectedCameraID(null);
    }
  }, [selectedCameraID, setCamera]);

  const sizeGroup = (visibleGroups.filter((g) => P.contains(g.name, PLACEHOLDERS.SizeKeyword)) ??
    [])[0];
  const sizeOptions = sizeGroup
    ? sizeGroup.attributes
        ?.flatMap(
          (attr) => attr?.options?.filter((option) => option && option.enabled !== false) || []
        )
        .filter((option): option is any => option !== undefined) || []
    : [];

  // Set initial selected size from the available options if not already set
  useEffect(() => {
    if (sizeOptions.length > 0) {
      const defaultSize = sizeOptions.find((opt) => opt.selected);
      if (defaultSize) {
        setSelectedSize(defaultSize.name);
      }
    }
  }, [sizeOptions]);

  const handleSizeClick = useCallback(
    (option: any): void => {
      setSelectedSize(option.name);
      selectOption(option.id);
    },
    [selectOption, setCamera]
  );

  const handleReset = useCallback(() => {
    if (visibleGroups.length > 0 && resetCameraID) {
      setCamera(resetCameraID);
    }
    setIsPopupOpen(false);
  }, [visibleGroups, resetCameraID, setCamera]);

  const handleUndoSingleStep = (actualUndoStep: UndoRedoStep) => {
    if (actualUndoStep.id === null && !isMobile) return;
    if (actualUndoStep.type === 'group')
      return setSelectedGroupId(findGroup(actualGroups, actualUndoStep.id)?.id ?? null);
    if (actualUndoStep.type === 'step')
      return setSelectedStepId(findStep(actualGroups, actualUndoStep.id)?.id ?? null);
    if (actualUndoStep.type === 'attribute')
      return setSelectedAttributeId(findAttribute(actualGroups, actualUndoStep.id)?.id ?? null);
    if (actualUndoStep.type === 'option') {
      return undo();
    }
  };

  const handleRedoSingleStep = (actualRedoStep: {
    type: string;
    id: number | null;
    direction: string;
  }) => {
    if (actualRedoStep.id === null && !isMobile) return;
    if (actualRedoStep.type === 'group')
      return setSelectedGroupId(findGroup(actualGroups, actualRedoStep.id)?.id ?? null);
    if (actualRedoStep.type === 'step')
      return setSelectedStepId(findStep(actualGroups, actualRedoStep.id)?.id ?? null);
    else if (actualRedoStep.type === 'attribute')
      return setSelectedAttributeId(findAttribute(actualGroups, actualRedoStep.id)?.id ?? null);
    else if (actualRedoStep.type === 'option') return redo();
  };

  const handleAddToCart = () => {
    if (product?.quantityRule) setQuantity(quantityValue);
    // Check if the product has mandatory personalization data and the value is less than 1
    if (isMandatoryPD && pdValue < 1) {
      setIsPDStartedFromCart(true);
      tryOnRef?.current?.setVisible?.(true);
      tryOnRef?.current?.changeMode?.(TryOnMode.PDTool);
      setTryOnMode(TryOnMode.PDTool);
      return;
    }

    // Check if there is a cart message visible and show a confirmation dialog
    const cartMessage = eventMessages?.find((message) => message.eventID === 4);
    if (cartMessage && cartMessage.visible && !isDraftEditor && !isEditorMode)
      showDialog(
        'question',
        <QuestionDialog
          alignButtons="center"
          eventMessage={cartMessage?.description}
          buttonNoLabel={T._('Cancel', 'Composer')}
          buttonYesLabel={T._('Add to cart', 'Composer')}
          onYesClick={() => {
            // Check if NFT is enabled and show the NFT dialog
            if (nftSettings && nftSettings.isNFTEnabled && !isDraftEditor)
              showDialog(
                'nft',
                <NftDialog
                  nftTitle={T._(
                    "You're purchasing a customized product together with an NFT.",
                    'Composer'
                  )}
                  nftMessage={T._(
                    'To confirm and mint your NFT you need an active wallet compatible with Ethereum. Confirm and add your email and wallet address.',
                    'Composer'
                  )}
                  price={nftSettings.priceToAdd + price}
                  buttonNoLabel={T._('Skip and continue', 'Composer')}
                  buttonYesLabel={T._('Confirm and Purchase', 'Composer')}
                  onYesClick={(nftForm: NftForm) => {
                    closeDialog('nft');
                    addToCart([], undefined, useLegacyScreenshot, nftForm);
                  }}
                  onNoClick={() => {
                    closeDialog('nft');
                    addToCart([], undefined, useLegacyScreenshot);
                  }}
                />
              );
            else addToCart([], undefined, useLegacyScreenshot);
            closeDialog('question');
          }}
        />
      );
    // If NFT is enabled, show the NFT dialog
    else if (nftSettings && nftSettings.isNFTEnabled && !isDraftEditor)
      showDialog(
        'nft',
        <NftDialog
          nftTitle={T._("You're purchasing a customized product together with an NFT.", 'Composer')}
          nftMessage={T._(
            'To confirm and mint your NFT you need an active wallet compatible with Ethereum. Confirm and add your email and wallet address.',
            'Composer'
          )}
          price={nftSettings.priceToAdd + price}
          buttonNoLabel={T._('Skip and continue', 'Composer')}
          buttonYesLabel={T._('Confirm and Purchase', 'Composer')}
          onYesClick={(nftForm: NftForm) => {
            closeDialog('nft');
            addToCart([], undefined, useLegacyScreenshot, nftForm);
          }}
          onNoClick={() => {
            closeDialog('nft');
            addToCart([], undefined, useLegacyScreenshot);
          }}
        />
      );
    // Otherwise, add the product to the cart
    else {
      addToCart([], undefined, useLegacyScreenshot);
    }
  };

  const handleUndoClick = useCallback(() => {
    if (undoStack.length === 0) return;

    setIsUndo(true);
    const stepsToUndo = undoStack[undoStack.length - 1];

    if (stepsToUndo && stepsToUndo.length > 0) {
      [...stepsToUndo].reverse().forEach((step) => {
        if (step.direction === 'undo') {
          switch (step.type) {
            case 'group':
              setSelectedGroupId(step.id);
              break;
            case 'step':
              setSelectedStepId(step.id);
              break;
            case 'attribute':
              setSelectedAttributeId(step.id);
              break;
            case 'option':
              undo();
              break;
          }
        }
      });
      undoRedoActions.fillRedoStack(stepsToUndo);
    }

    setIsUndo(false);
  }, [undoStack, undoRedoActions, setIsUndo, undo]);

  const handleRedoClick = useCallback(() => {
    if (redoStack.length === 0) return;
    setIsRedo(true);
    const stepsToRedo = redoStack[redoStack.length - 1];

    if (stepsToRedo && stepsToRedo.length > 0) {
      stepsToRedo.forEach((step: any) => {
        if (step.direction === 'redo') {
          switch (step.type) {
            case 'group':
              setSelectedGroupId(step.id);
              break;
            case 'step':
              setSelectedStepId(step.id);
              break;
            case 'attribute':
              setSelectedAttributeId(step.id);
              break;
            case 'option':
              redo();
              break;
          }
        }
      });
      undoRedoActions.fillUndoStack(stepsToRedo);
    }

    setIsRedo(false);
  }, [redoStack, undoRedoActions, setIsRedo, redo]);

  useEffect(() => {
    if (isStartRegistering) {
      undoRegistering.endRegistering(false);
      setIsStartRegistering(false);
    }
  }, [isStartRegistering]);

  const getGroupName = useCallback((group: Group): string => {
    if (P.contains(group.name, PLACEHOLDERS.StyleKeyword)) {
      return PLACEHOLDERS_MAPS[PLACEHOLDERS.StyleKeyword];
    }
    if (P.contains(group.name, PLACEHOLDERS.FabricKeyword)) {
      return PLACEHOLDERS_MAPS[PLACEHOLDERS.FabricKeyword];
    }
    if (P.contains(group.name, PLACEHOLDERS.WaistbandEmbroideryKeyword)) {
      return PLACEHOLDERS_MAPS[PLACEHOLDERS.WaistbandEmbroideryKeyword];
    }
    if (P.contains(group.name, PLACEHOLDERS.EmbellishmentsAndSponsorsKeyword)) {
      return PLACEHOLDERS_MAPS[PLACEHOLDERS.EmbellishmentsAndSponsorsKeyword];
    }
    return P._(group.name);
  }, []);

  const togglePopup = useCallback(() => {
    setIsPopupOpen((prev) => !prev);
  }, []);

  const handlePrevious = useCallback(() => {
    setOpenGroup((prev) => {
      if (prev === null || prev === 0) return visibleGroups.length - 1;
      return prev - 1;
    });
  }, [visibleGroups.length]);

  const handleNext = useCallback(() => {
    setOpenGroup((prev) => {
      if (prev === null || prev === visibleGroups.length - 1) return 0;
      return prev + 1;
    });
  }, [visibleGroups.length]);

  // console.log('visibleGroups', visibleGroups)

  const renderGroupContent = useCallback(
    (group: Group, groupName: string, index: number, total: number) => {
      const allOptions =
        group.attributes
          ?.flatMap(
            (attr) => attr?.options?.filter((option) => option && option.enabled !== false) || []
          )
          .filter((option): option is any => option !== undefined) || [];

      const selectedOptions = getSelectedOptions(group);
      const selectedText =
        selectedOptions.length > 0
          ? `${groupName.toUpperCase()}: ${selectedOptions
              .map((opt: Option) => opt.name)
              .join(', ')}`
          : '';
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { items, removeItem } = useZakeke();

      const handleStyleClick = (option: Option) => {
        const mockEvent = {
          preventDefault: () => {},
          stopPropagation: () => {},
        } as React.MouseEvent<HTMLElement>;

        handleOptionClick(mockEvent, option);
        if (!option.selected) removeItemsForStyle(items, removeItem);
        if (!option.selected) clearAllWaistbandSelections(visibleGroups, handleOptionClick);
      };
      if (P.contains(group.name, PLACEHOLDERS.StyleKeyword)) {
        return (
          <SubSection>
            <SubSectionTitle>
              <strong>Style</strong>
              {selectedText && `: ${selectedOptions.map((opt: Option) => opt.name).join(', ')}`}
            </SubSectionTitle>
            <OptionContainer>
              {allOptions.length > 0 ? (
                allOptions.map((option: Option) => (
                  <OptionItem
                    key={option.id}
                    option={option}
                    isStyle={true}
                    onOptionClick={() => handleStyleClick(option)}
                  />
                ))
              ) : (
                <div className="options-display">No boxing options available</div>
              )}
            </OptionContainer>
            {/* Navigation Buttons Container */}
            <div className="nav-buttons-container">
              <NavigationButton className="next" onClick={handleNext}>
                Next &gt;
              </NavigationButton>
            </div>
          </SubSection>
        );
      } else if (P.contains(group.name, PLACEHOLDERS.FabricKeyword)) {
        return (
          <SubSection>
            <FabricSection groups={visibleGroups} onOptionClick={handleOptionClick} />

            {/* Navigation Buttons Container */}
            <div className="nav-buttons-container">
              <NavigationButton className="previous" onClick={handlePrevious}>
                &lt; Previous
              </NavigationButton>
              <NavigationButton className="next" onClick={handleNext}>
                Next &gt;
              </NavigationButton>
            </div>
          </SubSection>
        );
      } else if (P.contains(group.name, PLACEHOLDERS.WaistbandEmbroideryKeyword)) {
        return (
          <SubSection>
            <WaistbandEmbroiderySection groups={visibleGroups} onOptionClick={handleOptionClick} />

            {/* Navigation Buttons Container */}
            <div className="nav-buttons-container">
              <NavigationButton className="previous" onClick={handlePrevious}>
                &lt; Previous
              </NavigationButton>
              <NavigationButton className="next" onClick={handleNext}>
                Next &gt;
              </NavigationButton>
            </div>
          </SubSection>
        );
      } else if (P.contains(group.name, PLACEHOLDERS.EmbellishmentsAndSponsorsKeyword)) {
        return (
          <SubSection>
            <DirectOptionsSection
              options={allOptions}
              onOptionClick={handleOptionClick}
              title="Customized Groups"
            />

            {/* Navigation Buttons Container */}
            <div className="nav-buttons-container">
              <NavigationButton className="previous" onClick={handlePrevious}>
                &lt; Previous
              </NavigationButton>
            </div>
          </SubSection>
        );
      } else {
        return (
          <div>
            <SubSection>
              <SubSectionTitle>
                <strong>{T._d(P._(group.name))}</strong>
                {selectedText && `: ${selectedOptions.map((opt: Option) => opt.name).join(', ')}`}
              </SubSectionTitle>
              <OptionContainer>
                {allOptions.map((option: Option) => (
                  <OptionItem
                    key={option.id}
                    option={option}
                    onOptionClick={(e: React.MouseEvent<HTMLElement>) =>
                      handleOptionClick(e, option)
                    }
                  />
                ))}
              </OptionContainer>

              {/* Navigation Buttons Container */}
              <div className="nav-buttons-container">
                {total > 1 && index > 0 && (
                  <NavigationButton className="previous" onClick={handlePrevious}>
                    &lt; Previous
                  </NavigationButton>
                )}
                {total > 1 && index < total - 1 && (
                  <NavigationButton className="next" onClick={handleNext}>
                    Next &gt;
                  </NavigationButton>
                )}
              </div>
            </SubSection>
          </div>
        );
      }
    },
    [handleOptionClick, visibleGroups, getSelectedOptions, handlePrevious, handleNext]
  );

  if (isSceneLoading || !visibleGroups || visibleGroups.length === 0 || isLoading) {
    return <Loader visible={true} />;
  }

  const getDescriptionByTitle = (title: string) => {
    if (title.includes('Classic Custom Boxing Shorts')) {
      return 'Keep it sharp and traditional with our Classic Customisable Boxing Shorts to replicate our Classic or Hagler style Boxing Shorts. Choose your colours, fabrics and personal details, then see your design come to life in 3D. Handcrafted in the UK for comfort, style and performance.';
    }

    if (title.includes('Side Stripes Custom Boxing Shorts')) {
      return 'Make a bold statement with our Side Stripes Customisable Boxing Shorts, inspired by iconic ring styles such as Side Stripes and Royalty. Add your own colours, fabrics and personal details, then bring your vision to life in 3D. Handcrafted in the UK for maximum impact, comfort and performance.';
    }

    return '';
  };

  // console.log(product)
  return (
    <Container className="selector-container" ref={ref}>
      <div className="main_menue_style scrollbar-thin">
        <h1 className="product-title main-container">{product?.name}</h1>
        <p className="paragraph">{product && getDescriptionByTitle(product.name)}</p>

        <div className="size-selector">
          <div className="size-label size-css">Size: {selectedSize}</div>
          <div className="size-buttons size-buttons-css">
            {sizeOptions.length > 0 && (
              <div className="size-container">
                <div className="size-buttons-container">
                  {sizeOptions.map((option: Option) => (
                    <div
                      key={option.id}
                      onClick={() => handleSizeClick(option)}
                      className="size-options"
                      style={{
                        border: selectedSize === option.name ? '1px solid #000' : '1px solid #000',
                        backgroundColor: selectedSize === option.name ? '#000000' : 'transparent',
                        color: selectedSize === option.name ? 'white' : '#000',
                      }}
                    >
                      {option.name}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="info-bar">
          <div className="">
            <a href="https://suziwong.co.uk/size-guides/" target="_blank" className="size-guide">
              <div className="info-item">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.66101 0.898315C4.41187 0.898315 0.322021 3.02374 0.322021 5.72882V9.2712C0.322021 9.59213 0.375157 9.93944 0.504863 10.2653C0.195296 10.5339 0 10.9359 0 11.3966V12.6526C0 13.4576 0.64408 14.1017 1.44915 14.1017H3.54238H4.18646H9.66101C9.85034 14.1017 10.0379 14.0986 10.2241 14.0932C10.2496 14.0986 10.2766 14.1017 10.3051 14.1017C10.3363 14.1017 10.3674 14.0968 10.3974 14.0876C10.9031 14.0681 11.3961 14.0285 11.8739 13.9706C11.8873 13.972 11.901 13.9729 11.9152 13.9729C11.9485 13.9729 11.9816 13.9657 12.0134 13.9534C12.5418 13.8851 13.0507 13.7941 13.5364 13.6824C13.5698 13.6809 13.6029 13.6727 13.6344 13.6592C16.8351 12.9 19 11.2391 19 9.27124V5.72882C19 3.02374 14.9101 0.898315 9.66101 0.898315ZM9.66101 1.5424C14.3627 1.5424 18.3559 3.4746 18.3559 5.72882C18.3559 7.98304 14.3627 9.91525 9.66101 9.91525C4.95931 9.91525 0.966101 7.98304 0.966101 5.72882C0.966101 3.4746 4.95931 1.5424 9.66101 1.5424ZM1.06271 9.91525C0.998292 9.68984 0.966101 9.49661 0.966101 9.27117V7.53218C1.04214 7.63042 1.12434 7.72699 1.21204 7.82198C1.97273 8.66041 3.18327 9.35985 4.69419 9.84184C4.77114 9.86679 4.84858 9.89136 4.92715 9.91521H4.18646H3.54238H1.44915H1.06271V9.91525ZM3.54238 13.4576H1.44915C0.998292 13.4576 0.64408 13.1034 0.64408 12.6203V11.3644C0.64408 10.9135 0.99833 10.5593 1.44915 10.5593H3.54238V13.4576ZM18.3559 9.2712C18.3559 9.51118 18.3103 9.74746 18.2237 9.97823C18.1682 9.938 18.1011 9.91528 18.0339 9.91528C17.8406 9.91528 17.7118 10.0441 17.7118 10.2373V10.815C17.531 11.0253 17.3153 11.2279 17.0678 11.4209V11.2034C17.0678 11.0102 16.939 10.8814 16.7457 10.8814C16.5525 10.8814 16.4237 11.0102 16.4237 11.2034V11.8591C16.1288 12.0358 15.8057 12.2014 15.4576 12.354V11.8474C15.4576 11.6542 15.3288 11.5254 15.1356 11.5254C14.9424 11.5254 14.8136 11.6542 14.8136 11.8474V12.6113C14.506 12.723 14.183 12.8251 13.8475 12.917V12.4915C13.8475 12.2983 13.7187 12.1695 13.5255 12.1695C13.3322 12.1695 13.2034 12.2983 13.2034 12.4915V13.0772C12.8902 13.1472 12.5676 13.2083 12.2373 13.26V12.8136C12.2373 12.6204 12.1085 12.4916 11.9153 12.4916C11.7221 12.4916 11.5933 12.6204 11.5933 12.8136V13.3475C11.2769 13.384 10.9543 13.4115 10.6272 13.43V12.8136C10.6272 12.6204 10.4984 12.4916 10.3052 12.4916C10.1119 12.4916 9.98315 12.6204 9.98315 12.8136V13.4543C9.87616 13.4563 9.7689 13.4576 9.66112 13.4576H9.01704V12.8135C9.01704 12.6203 8.88824 12.4915 8.69502 12.4915C8.5018 12.4915 8.373 12.6203 8.373 12.8135V13.4576H7.4069V12.8135C7.4069 12.6203 7.2781 12.4915 7.08488 12.4915C6.89166 12.4915 6.76286 12.6203 6.76286 12.8135V13.4576H5.79676V12.8135C5.79676 12.6203 5.66796 12.4915 5.47474 12.4915C5.28152 12.4915 5.15271 12.6203 5.15271 12.8135V13.4576H4.18661V10.5593H9.66101C9.73392 10.5593 9.80653 10.5588 9.87899 10.558C9.90608 10.5577 9.9331 10.5572 9.96012 10.5568C10.0033 10.5561 10.0464 10.5553 10.0894 10.5543C10.1252 10.5535 10.161 10.5526 10.1967 10.5517C10.2226 10.5509 10.2484 10.55 10.2743 10.5492C13.575 10.4437 16.3525 9.49145 17.8376 8.09818C17.8424 8.09373 17.8471 8.08924 17.8519 8.08475C17.8691 8.06848 17.8864 8.05229 17.9032 8.03591C18.0723 7.87338 18.2238 7.70529 18.3559 7.53222V9.2712Z"
                    fill="black"
                  />
                  <path
                    d="M9.66111 8.62711C12.7204 8.62711 15.1357 7.33899 15.1357 5.72881C15.1357 4.11863 12.7204 2.83051 9.66111 2.83051C6.60178 2.83051 4.18652 4.11863 4.18652 5.72881C4.18652 7.33899 6.60178 8.62711 9.66111 8.62711ZM9.66111 3.47459C12.2696 3.47459 14.4916 4.50511 14.4916 5.72881C14.4916 6.95255 12.2696 7.98303 9.66111 7.98303C7.05264 7.98303 4.8306 6.95255 4.8306 5.72881C4.8306 4.50507 7.05264 3.47459 9.66111 3.47459Z"
                    fill="black"
                  />
                  <path
                    d="M9.661 7.33901C11.3034 7.33901 12.5593 6.66274 12.5593 5.72883C12.5593 4.79492 11.3034 4.11865 9.661 4.11865C8.01863 4.11865 6.7627 4.79492 6.7627 5.72883C6.7627 6.66274 8.01863 7.33901 9.661 7.33901ZM9.661 4.76273C10.9491 4.76273 11.9152 5.27797 11.9152 5.72883C11.9152 6.17969 10.9491 6.69493 9.661 6.69493C8.37288 6.69493 7.40678 6.17969 7.40678 5.72883C7.40678 5.27797 8.37288 4.76273 9.661 4.76273Z"
                    fill="black"
                  />
                  <path
                    d="M0.966309 12.0085C0.966309 12.6203 1.48155 13.1356 2.09344 13.1356C2.70533 13.1356 3.22057 12.6204 3.22057 12.0085C3.22057 11.3966 2.70533 10.8813 2.09344 10.8813C1.48155 10.8813 0.966309 11.3966 0.966309 12.0085ZM2.09344 11.5254C2.35108 11.5254 2.57649 11.7508 2.57649 12.0085C2.57649 12.2661 2.35108 12.4915 2.09344 12.4915C1.8358 12.4915 1.61039 12.2661 1.61039 12.0085C1.61039 11.7508 1.8358 11.5254 2.09344 11.5254Z"
                    fill="black"
                  />
                </svg>
                <span className="label">Size Guides</span>
              </div>
            </a>
          </div>
          <div className="divider" />
          <div className="">
            <a
              href="https://suziwong.co.uk/product-category/3d-custom-boxing-designer/"
              target="_blank"
              className="size-guide"
            >
              <div className="info-item">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_31_81)">
                    <path
                      d="M16.2453 5.75887L15.9613 1.26109C15.9613 0.896778 15.6773 0.630554 15.308 0.630554H3.42239C3.05318 0.630554 2.76918 0.896778 2.76918 1.26109L2.48517 5.75887L-0.0424805 17.9912L8.5771 18.986L9.41492 16.8282L10.2527 18.986L18.8723 17.9912L16.3447 5.75887H16.2453ZM15.4074 5.3105H14.4702V1.44324H15.2228L15.4074 5.40858V5.3105ZM4.91342 5.3105V1.44324H6.03525V5.3105H4.91342ZM6.41866 1.44324H7.54048V5.3105H6.41866V1.44324ZM8.00909 1.44324H9.13091V5.3105H8.00909V1.44324ZM9.59952 1.44324H10.7213V5.3105H9.59952V1.44324ZM11.19 1.44324H12.3118V5.3105H11.19V1.44324ZM12.7804 1.44324H13.9022V5.3105H12.7804V1.44324ZM3.607 1.44324H4.35961V5.3105H3.42239L3.607 1.34516V1.44324ZM10.1675 16.646C10.0681 16.3798 9.69893 16.0996 9.41492 16.0996C9.13091 16.0996 8.7617 16.2817 8.6623 16.646L8.09429 18.1733L1.07934 17.3747L3.32299 6.12318H15.4926L17.8357 17.2766L10.8065 18.0893L10.2385 16.562L10.1675 16.646Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_31_81">
                      <rect width="19" height="19" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span className="label">More Customisable Designs</span>
              </div>
            </a>
          </div>
          <div className="divider" />
          <div>
            <a
              href="https://suziwong.co.uk/delivery-production/"
              target="_blank"
              className="info-item size-guide"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_31_77)">
                  <path
                    d="M9 0.75C7.36831 0.75 5.77325 1.23385 4.41655 2.14038C3.05984 3.0469 2.00242 4.33537 1.378 5.84286C0.753575 7.35035 0.590197 9.00915 0.908525 10.6095C1.22685 12.2098 2.01259 13.6798 3.16637 14.8336C4.32016 15.9874 5.79017 16.7732 7.39051 17.0915C8.99085 17.4098 10.6497 17.2464 12.1571 16.622C13.6646 15.9976 14.9531 14.9402 15.8596 13.5835C16.7661 12.2268 17.25 10.6317 17.25 9C17.2476 6.8127 16.3777 4.71566 14.831 3.169C13.2843 1.62234 11.1873 0.752382 9 0.75ZM9 15.75C7.66498 15.75 6.35994 15.3541 5.2499 14.6124C4.13987 13.8707 3.27471 12.8165 2.76382 11.5831C2.25293 10.3497 2.11925 8.99251 2.3797 7.68314C2.64015 6.37377 3.28303 5.17103 4.22703 4.22703C5.17104 3.28302 6.37377 2.64015 7.68314 2.3797C8.99252 2.11925 10.3497 2.25292 11.5831 2.76381C12.8165 3.2747 13.8707 4.13987 14.6124 5.2499C15.3541 6.35993 15.75 7.66498 15.75 9C15.748 10.7896 15.0362 12.5053 13.7708 13.7708C12.5053 15.0362 10.7896 15.748 9 15.75ZM9.75 6H8.25V10.5H12.75V9H9.75V6Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_31_77">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span className="label">4 Weeks Production </span>
            </a>
          </div>

          <div className="divider" />
          <div>
            <a
              href="https://suziwong.co.uk/how-to-use-the-3d-designer/"
              target="_blank"
              className="info-item size-guide"
            >
              <svg
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 122.88 111.34"
              >
                <title>video</title>
                <path d="M23.59,0h75.7a23.68,23.68,0,0,1,23.59,23.59V87.75A23.56,23.56,0,0,1,116,104.41l-.22.2a23.53,23.53,0,0,1-16.44,6.73H23.59a23.53,23.53,0,0,1-16.66-6.93l-.2-.22A23.46,23.46,0,0,1,0,87.75V23.59A23.66,23.66,0,0,1,23.59,0ZM54,47.73,79.25,65.36a3.79,3.79,0,0,1,.14,6.3L54.22,89.05a3.75,3.75,0,0,1-2.4.87A3.79,3.79,0,0,1,48,86.13V50.82h0A3.77,3.77,0,0,1,54,47.73ZM7.35,26.47h14L30.41,7.35H23.59A16.29,16.29,0,0,0,7.35,23.59v2.88ZM37.05,7.35,28,26.47H53.36L62.43,7.38v0Zm32,0L59.92,26.47h24.7L93.7,7.35Zm31.32,0L91.26,26.47h24.27V23.59a16.32,16.32,0,0,0-15.2-16.21Zm15.2,26.68H7.35V87.75A16.21,16.21,0,0,0,12,99.05l.17.16A16.19,16.19,0,0,0,23.59,104h75.7a16.21,16.21,0,0,0,11.3-4.6l.16-.18a16.17,16.17,0,0,0,4.78-11.46V34.06Z" />
              </svg>
              <span className="label">SHOW ME HOW </span>
            </a>
          </div>
        </div>

        <div className="left-keys">
          <Zoom zoomIn={zoomIn} zoomOut={zoomOut} />
        </div>

        <div className="menu-container menu-container-css">
          <div className="menu">
            <MenuGroup className="menu-group">
              {visibleGroups
                .filter((g) => !P.isHidden(g.name))
                .map((group, index) => {
                  const isOpen = openGroup === index; // Check if current group is open
                  return (
                    <div key={group.id} className="group-item group-positon">
                      <MenuItem
                        className="menu-item"
                        onClick={() => handleGroupClick(group, index)}
                      >
                        {T._d(getGroupName(group))}
                        <SvgArrowDown
                          style={{
                            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          }}
                          className="arrow-icon group-svg"
                        />
                      </MenuItem>
                      {isOpen && (
                        <ExpandedContent className="options-content">
                          {renderGroupContent(
                            group,
                            group.name,
                            index,
                            visibleGroups.filter((g) => !P.isHidden(g.name)).length
                          )}
                        </ExpandedContent>
                      )}
                    </div>
                  );
                })}
            </MenuGroup>
            {screenWidth < 500 && (
              <div className="mobile-footer">
                <MenuFooter
                  viewFooter={viewFooter}
                  isUndo={handleUndoClick}
                  isRedo={handleRedoClick}
                  setOpenGroup={setOpenGroup}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {screenWidth > 500 && (
        <div className="desktop-footer">
          <MenuFooter
            viewFooter={viewFooter}
            isUndo={handleUndoClick}
            isRedo={handleRedoClick}
            setOpenGroup={setOpenGroup}
          />
        </div>
      )}
    </Container>
  );
};

export default Selector;
